import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { HeadSection } from 'src/components/elements'
import { useGetMyPropertiesQuery } from 'src/redux/api'
import MyPropertyCard from './item/MyPropertyCard'

interface IMyPropertiesProfile {}

// "Мої пропозиції" — the listings the current user has created. Hidden when the
// user has none so pure seekers do not see an empty block.
const MyPropertiesProfile: FC<IMyPropertiesProfile> = () => {
  const { t } = useTranslation()
  const { data } = useGetMyPropertiesQuery(undefined)
  const items = data?.items ?? []

  if (!items.length) return null

  return (
    <section className="md:mt-1.5 flex flex-col gap-3">
      <HeadSection title={t('my_offers.title')} />
      {/* rows, two per line on a wide screen: the numbers and actions of each
          listing stay readable instead of a strip of narrow cards */}
      <div className="grid gap-3 md:grid-cols-2">
        {items.map((item) => (
          <MyPropertyCard key={item.id} {...item} />
        ))}
      </div>
    </section>
  )
}

export default MyPropertiesProfile
